<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw Preface-rw" epub:type="frontmatter preface" id="preface1">
<h1 class="preface-title"><span href="#/toc#toc-preface002" title="Link target outside of Sample">Note</span></h1>
<p class="noindent">T<span class="small-caps">HERE COMES A</span> moment in the life of every individual when reality must be faced. When this happens, it is as though a link between emotion and reason is stretched to the limit of endurance, and sometimes snaps. In this collection of stories, men, women, children and a nation are brought to the breaking point. Whether the link survives or snaps, the reader must judge for himself.</p></section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface002.vue?10ce41cb